import React from "react";
import { withRouter } from "react-router-dom";
import { Skeleton } from "@material-ui/lab/";
import { Button } from "@material-ui/core/";
import { Formik } from "formik";
import { TenantBrandingSchema } from "../../../helpers/schemas";
import { MappedInput } from "../../components/Input";
import { useFetch } from "../../../hooks/fetch.hook";
import { TenantLogoUpload } from "./TenantLogoUpload";

function TenantBrandingForm({
  history,
  data,
  onClose,
  onSubmit,
  setData,
  tenantId,
}) {
  const { request } = useFetch();

  const { brand_logo, icon } = data;

  const initialValues = {
    brand_logo: brand_logo || "",
    icon: icon || "",
  };

  const handleOnBlur = (e) => {
    setData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  if (!Object.keys(data).length) {
    return <Skeleton variant="rect" width={"100%"} height={812} />;
  }

  const handleSubmit = (values) => {
    request(
      onSubmit,
      { tenant_id: tenantId, ...data, ...values },
      data.id
    ).then((data) => {
      if (data) {
        if (onClose) return onClose(false);
        return history.push(`/tenants-list/`);
      }
    });
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={TenantBrandingSchema}
      onSubmit={handleSubmit}
    >
      {(props) => (
        <div className="bg-white rounded">
          <div className="bg-white rounded">
            <div className="px-21 py-19" style={{ minHeight: 712.5 }}>
              <div className="row mb-3">
                <div className="col-2 my-auto">
                  <p className="text-right text-muted mb-0">
                    Tenant Brand Icon
                  </p>
                </div>
                <div className="col-3 mr-auto">
                  <MappedInput
                    onBlur={handleOnBlur}
                    name="icon"
                    wrapperClassName="w-100"
                    data-testid="icon"
                  />
                </div>
              </div>

              <div className="d-flex justify-content-end align-items-center">
                <Button
                  variant="outlined"
                  color="secondary"
                  size="large"
                  className="px-9 mr-3"
                  data-testid="cancel"
                  onClick={
                    onClose ? () => onClose(false) : () => history.go(-1)
                  }
                >
                  Cancel
                </Button>
                <Button
                  onClick={props.handleSubmit}
                  variant="contained"
                  color="secondary"
                  size="large"
                  className="px-9"
                  data-testid="submit"
                >
                  Save
                </Button>
              </div>
              <div className="row mb-3 mt-10">
                <div className="col-2 my-auto">
                  <p className="text-right text-muted mb-0">
                    Tenant Brand Icon
                  </p>
                </div>
                <div className="col-10 mr-auto">
                  <TenantLogoUpload
                    data={data}
                    tenant_id={tenantId}
                    setCardData={setData}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Formik>
  );
}

export default withRouter(TenantBrandingForm);
